module.exports = __webpack_public_path__ + "static/media/terms003.ba3ddaa6.png";